import type { JSX } from "react";
interface Props {
  size: string | number;
  className?: string;
}

export const TrashIcon = ({ size, className }: Props): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" className={className}>
    <g clipPath="url(#a)">
      <path d="M16 9v10H8V9h8Zm-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1ZM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
